import { useEffect, useState } from "react";
import { ListChecks } from "lucide-react";
import { useApi, fmtDate } from "@/lib/api";
import { t, locale } from "@/i18n";

export function ChecklistRuns({ sopId }) {
  const api = useApi();
  const [runs, setRuns] = useState([]);
  useEffect(() => { api.get("/checklist-runs", { params: { sop_id: sopId } }).then((r) => setRuns(r.data)); }, [api, sopId]);
  return (
    <div className="card" data-testid="checklist-runs-panel">
      <p className="mono-label flex items-center gap-2 mb-2"><ListChecks size={13} /> {t("Shift checklist runs")} ({runs.length})</p>
      {runs.length === 0 && <p className="text-sm faint">{t("No runs yet.")}</p>}
      {runs.slice(0, 8).map((r) => (
        <div key={r.id} className="py-2 border-b border-[var(--border-color)] last:border-0 text-sm" data-testid={`checklist-run-${r.id}`}>
          <div className="flex justify-between gap-2"><span className="font-semibold truncate">{r.user_name || t("Staff")}</span>
            <span className={`chip ${r.complete ? "chip-accent" : "chip-warn"}`}>{t("{a}/{b} steps", { a: r.checked_steps.length, b: r.total_steps })}</span></div>
          <p className="text-xs faint">{fmtDate(r.completed_at)} {new Date(r.completed_at).toLocaleTimeString(locale(), { hour: "2-digit", minute: "2-digit" })} · v{r.version}{r.note && ` · “${r.note}”`}</p>
        </div>
      ))}
    </div>
  );
}
